<template>
  <apex-chart v-if="hasData" type="line" height="100%" width="95%" :series="chartSeries" :options="chartOptions"></apex-chart>
</template>
<script>
import DataManager, { chart_locales } from "../../js/DataManager";
import { TR } from "../../main";
export default {
  data() {
    return {
      hasData: false,
      zzTickAmount: 5,
      chartData: [],
      chartSeries: [],
      chartCategory: [],
      /** @type {ApexCharts.ApexOptions} */
      chartOptions: {
        chart: {
          animations: {
            enabled: false,
            // animateGradually: {
            //   enabled: false,
            // },
            // dynamicAnimation: {
            //   enabled: false,
            // },
          },
          locales: chart_locales,
          defaultLocale: "bg",
          id: "DevicePercentDiscount",
          type: "line",
          toolbar: {
            show: false,
            //download: this.getIconString("mdi-download"),
          },
          zoom: {
            enabled: false,
          },
        },
        markers: {
          size: 0,
        },
        title: {
          text: TR.DiscountForDevCount,
          style: {
            fontSize: "14px",
            fontWeight: "regular",
            fontFamily: undefined,
            //color: "#263238",
          },
        },
        xaxis: {
          type: "numeric",
          categories: [],
        },
        yaxis: {
          labels: {
            formatter: (val) => val.toFixed(2) + "%",
            style: {
              colors: "#05733F",
            },
          },
          title: {
            style: {
              color: "#05733F",
            },
          },
        },
        tooltip: {
          shared: false,
          x: {
            formatter: (val) => TR.WhenSubscribing + " " + val + " " + TR.Dev,
          },
          marker: {
            show: false,
          },
        },
      },
      zzBackground: "#FFF",
      zzForeground: "#000",
      zzTheme: "light",
    };
  },
  computed: {},
  methods: {
    refreshChartData() {
      this.hasData = false;
      this.chartSeries = [];
      this.chartOptions = {
        ...this.chartOptions,
        ...{
          theme: {
            mode: this.zzTheme,
          },
          chart: {
            ...this.chartOptions.chart,
            ...{
              background: this.zzBackground,
              foreColor: this.zzForeground,
            },
          },
          xaxis: {
            type: "numeric",
            tickAmount: this.zzTickAmount,
            categories: this.chartCategory,
          },
        },
      };
      this.chartSeries = [{ name: TR.PercentDiscount, data: this.chartData }];
      this.hasData = true;
    },
    refreshTheme() {
      this.$nextTick(() => {
        this.zzTickAmount = this.isWithSmallWidth ? 6 : 10;
        if (this.isInDarkMode) {
          if (this.zzTheme == "dark") return;
          this.zzBackground = "#1E1E1E";
          this.zzForeground = "#FFF";
          this.zzTheme = "dark";
        } else {
          if (this.zzTheme == "light") return;
          this.zzBackground = "#FFF";
          this.zzForeground = "#000";
          this.zzTheme = "light";
        }
        this.refreshChartData();
      });
    },
  },
  updated() {},
  mounted() {
    this.discounts = DataManager.getData(DataManager.DataType.discounts);
    this.chartCategory = this.discounts.map((d) => d.fuCount);
    this.chartData = this.discounts.map((d) => d.percent);

    this.$nextTick(() => {
      this.refreshChartData();
    });
  },
  watch: {},
};
</script>